import { cn } from '@commander/ui';
import type React from 'react';

interface SuggestionsProps {
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
  className?: string;
  layout?: 'default' | 'vertical' | 'horizontal';
  size?: 'sm' | 'md' | 'lg';
}

const Suggestions: React.FC<SuggestionsProps> = ({
  suggestions,
  onSuggestionClick,
  className,
  layout = 'default',
  size = 'md',
}) => {
  const containerClassName = cn(
    'flex',
    layout === 'default' && 'flex-row gap-2',
    layout === 'vertical' && 'flex-col max-w-[60px] w-auto gap-1',
    layout === 'horizontal' && 'flex-row flex-wrap gap-2',
    className
  );

  const buttonClassName = cn(
    'px-2 py-1 rounded-md font-paragraph text-heading-4 text-[#454A51]',
    'hover:bg-gray-300 transition-colors duration-300 cursor-pointer',
    'bg-[#EEF0F2]',
    size === 'sm' && 'text-xs px-2 py-1',
    size === 'md' && 'text-sm px-3 py-2',
    size === 'lg' && 'text-base px-4 py-3'
  );

  if (suggestions.length === 0) {
    return null;
  }

  return (
    <div className={containerClassName}>
      {suggestions.map((suggestion) => (
        <button
          key={suggestion}
          onClick={() => onSuggestionClick(suggestion)}
          className={buttonClassName}
          type="button"
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
};

export default Suggestions;
